export const getDevicePixelRatio = () =>
  (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
